export default __webpack_public_path__ + "static/media/calendar-iteration.e27b9818.png";